import { takeLast } from 'ramda'

export const getLocation = (pathname) => {
  if (pathname === '/') {
    return 'home'
  }

  return takeLast(pathname.length - 1)(pathname)
}
